











import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({})
export default class ShareImgPage extends Vue {
  @Prop() picUrl: any
  @Prop() close: any
  @Prop({ default: '长按海报保存到本地或分享给好友' }) tipText: string
}
